import { addLocale, PrimeReactProvider } from 'primereact/api';
import { type PropsWithChildren, useEffect, useState } from 'react';
import { resolveLocale } from '../fields/calendar/calendar-functions';

function PrimeReactComponentProvider({ children }: PropsWithChildren) {
  const [locale, setLocale] = useState<string | undefined>();

  useEffect(() => {
    resolveLocale().then(({ locale, options }) => {
      addLocale(locale, options as object);
      setLocale(locale);
    });
  }, []);

  if (!locale) {
    return null;
  }

  return <PrimeReactProvider value={{ locale }}>{children}</PrimeReactProvider>;
}

export default PrimeReactComponentProvider;
